
export default {
	list: 'DirectInvestmentValuation',
	columns: {
		Id: {
			class: 'id',
			dataName: 'Id',
			type: 'number',
			title: 'Id',
			width: 100,
			hidden: true,
			readOnly: false
		},
		InvestmentId: {
			class: "lookup",
			dataName: 'InvestmentId',
			type: 'number',
			title: 'Investment Id',
			width: 100,
			hidden: false,
			readOnly: false
		},
		InvestmentInvestmentID: {
			class: "lookup",
			dataName: 'Investment/InvestmentID',
			type: 'string',
			title: 'Investment ID',
			width: 100,
			hidden: false,
			readOnly: true
		},
		InvestmentTitle: {
			class: "lookup",
			dataName: 'Investment/Title',
			type: 'string',
			title: 'Investment Name',
			width: 100,
			hidden: false,
			readOnly: true
		},
		PartnerId: {
			class: "lookup",
			dataName: 'PartnerId',
			type: 'number',
			title: 'Partner Id',
			width: 100,
			hidden: false,
			readOnly: false
		},
		PartnerPartnerID: {
			class: "lookup",
			dataName: 'Partner/PartnerID',
			type: 'string',
			title: 'Partner ID',
			width: 100,
			hidden: false,
			readOnly: true
		},
		PartnerFullName: {
			class: "lookup",
			dataName: 'Partner/FullName',
			type: 'string',
			title: 'Partner Name',
			width: 100,
			hidden: false,
			readOnly: true
		},
		TaxYear: {
			class: "choice",
			dataName: 'TaxYear',
			type: 'string',
			title: 'Tax Year',
			width: 100,
			hidden: false,
			readOnly: false
		},
		TaxQuarter: {
			class: "choice",
			dataName: 'TaxQuarter',
			type: 'string',
			title: 'Tax Quarter',
			width: 100,
			hidden: false,
			readOnly: false
		},
		TaxYearQuarter: {
			class: "value",
			dataName: 'TaxYearQuarter',
			type: 'string',
			title: 'Tax Period',
			width: 100,
			hidden: false,
			readOnly: true
		},
		CommitmentFunded: {
			class: "value",
			dataName: 'CommitmentFunded',
			type: 'number',
			title: 'Commitment Funded',
			template: '<span class="number-cell-ui">#=kendo.toString(CommitmentFunded)#</span>',
			width: 100,
			hidden: false,
			readOnly: false
		},
		CommitmentRemaining: {
			class: "value",
			dataName: 'CommitmentRemaining',
			type: 'number',
			title: 'Commitment Remaining',
			template: '<span class="number-cell-ui">#=kendo.toString(CommitmentRemaining)#</span>',
			width: 100,
			hidden: false,
			readOnly: false
		},
		PriorCashDistribution: {
			class: "value",
			dataName: 'PriorCashDistribution',
			type: 'number',
			title: 'Prior Cash Distribution',
			template: '<span class="number-cell-ui">#=kendo.toString(PriorCashDistribution)#</span>',
			width: 100,
			hidden: false,
			readOnly: false
		},
		ProjectedValue: {
			class: "value",
			dataName: 'ProjectedValue',
			type: 'number',
			title: 'Projected Value',
			template: '<span class="number-cell-ui">#=kendo.toString(ProjectedValue)#</span>',
			width: 100,
			hidden: false,
			readOnly: false
		},
		CurrentValue: {
			class: "value",
			dataName: 'CurrentValue',
			type: 'number',
			title: 'Current Value',
			width: 100,
			template: '<span class="number-cell-ui">#=kendo.toString(CurrentValue)#</span>',
			hidden: false,
			readOnly: false
		},
		Note: {
			class: 'value',
			dataName: 'Note',
			type: 'string',
			title: 'Note',
			width: 100,
			hidden: false,
			readOnly: false
		}
	},
}